function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DateRangeShortcutHelper, i18n, MetadataActions, MetadataConstants, MetadataSelectors, SessionSelectors } from 'invision-core';
import { RIGHT_ALIGNED_HEADER_TEMPLATE } from 'invision-ui/lib/components/collections/datatable/cellTemplates/cellTemplates';
import { pathOr, pluck } from 'ramda';
import { stateGo } from 'redux-ui-router';
import { TRANSACTION_DETAILS_STATE } from '../transactions.config';
import { NOTIFICATION_TIME_LENGTH } from './../../../../customercare.constants';
import LocaleKeys from './../../../../locales/keys';
import { retrieveWallet } from './../../../../reducers/actions/customer.ewallet.actions';
import * as TransactionActions from './../../../../reducers/actions/customer.transactions.actions';
import { IsRetrievingEwalletDataSelector, PaymentInstrumentsSelector } from './../../../../reducers/selectors/customer.ewallet.selectors';
import { CurrentCustomerIdSelector, CurrentCustomerSelector, RouteParams, RouteState } from './../../../../reducers/selectors/customer.selectors';
import * as TransactionSelectors from './../../../../reducers/selectors/customer.transactions.selectors';
var PAGER_MAX_SLOTS = 5;
var TransactionsListController = /*#__PURE__*/function () {
  function TransactionsListController($ngRedux, uiNotificationService) {
    _classCallCheck(this, TransactionsListController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      paymentInstrumentIdLoadedFromUrl: false,
      LocaleKeys: LocaleKeys,
      onBannerClose: this.onBannerClose.bind(this),
      onBrandableCurrencySelected: this.onBrandableCurrencySelected.bind(this),
      onCurrencySelected: this.onCurrencySelected.bind(this),
      onDateRangeChanged: this.onDateRangeChanged.bind(this),
      onPageSelected: this.onPageSelected.bind(this),
      onPaymentInstrumentSelected: this.onPaymentInstrumentSelected.bind(this),
      onTransactionTypeSelected: this.onTransactionTypeSelected.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(TransactionsListController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.columnDefs = [{
        field: 'Created',
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.DATE),
        width: 145,
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'Id',
        cellTemplate: require('./cellTemplates/id.template.html'),
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.TRANSACTION_ID),
        width: 90,
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'TypeName',
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.TYPE),
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'RetriedByTransactionId',
        width: 120,
        cellTemplate: require('./cellTemplates/retriedtransactionid.template.html'),
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.RETRIED_TRANSACTION_ID),
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'PurchasedProducts',
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.DESCRIPTION),
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'ResultName',
        width: 150,
        cellTemplate: require('./cellTemplates/status.template.html'),
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.RESULT),
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'OriginalAmount',
        cellTemplate: require('./cellTemplates/smart.truncate.cell.template.html'),
        headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.PAYMENT),
        width: 150,
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'TotalCreditAmount',
        cellTemplate: require('./cellTemplates/discount.template.html'),
        headerCellClass: 'u-pr+',
        headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.DISCOUNT),
        width: 150,
        enableColumnResizing: true,
        enableSorting: false
      }, {
        field: 'Balance',
        cellTemplate: require('./cellTemplates/amount.template.html'),
        headerCellClass: 'u-pr++',
        displayName: i18n.translate(LocaleKeys.TRANSACTIONS.COLUMNS.AMOUNT),
        headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE,
        minWidth: 100,
        enableColumnResizing: true,
        enableSorting: false
      }];
      var mapStateToTarget = function mapStateToTarget(store) {
        var transactionList = TransactionSelectors.TableDataSelector(store);
        var hasRetriedTransaction = (transactionList || []).some(function (transaction) {
          return transaction.RetriedByTransactionId !== null && transaction.RetriedByTransactionId !== undefined;
        });
        var columnDefs = hasRetriedTransaction ? _this.columnDefs : _this.columnDefs.filter(function (col) {
          return col.field !== 'RetriedByTransactionId';
        });
        return {
          areBrandableCurrenciesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.BrandableCurrency, store),
          areCurrenciesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.Currency, store),
          areTransactionTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TransactionType, store),
          arrivedFromSearch: TransactionSelectors.CurrentTransactionFromSearchSelector(store),
          brandableCurrencies: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.BrandableCurrency, store),
          brandableCurrency: TransactionSelectors.BrandableCurrencySelector(store),
          brandableCurrencyOptions: TransactionSelectors.BrandableCurrencyCodeOptionsSelector(store),
          currencies: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.Currency, store),
          currency: TransactionSelectors.CurrencySelector(store),
          currencyOptions: TransactionSelectors.CurrencyCodeOptionsSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentRoute: RouteState(store),
          currentRouteParams: RouteParams(store),
          endDate: TransactionSelectors.EndDateSelector(store),
          endRecord: TransactionSelectors.EndRecordSelector(store),
          hasFiltersSelected: TransactionSelectors.HasSelectedTransactionFilters(store),
          hasLoadedTransactions: TransactionSelectors.HasLoadedTransactions(store),
          isFetchingData: TransactionSelectors.IsFetchingDataSelector(store),
          isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
          lockerItemId: TransactionSelectors.LockerItemIdSelector(store),
          maximumSlots: PAGER_MAX_SLOTS,
          numberOfPages: TransactionSelectors.TotalPagesSelector(store),
          pageNumber: TransactionSelectors.PageNumberSelector(store),
          paymentInstrument: TransactionSelectors.PaymentInstrumentSelector(store),
          paymentInstrumentIdUrlSearchParam: TransactionSelectors.PaymentInstrumentIdUrlSearchParamSelector(store),
          paymentInstrumentOptions: TransactionSelectors.PaymentInstrumentOptionsSelector(store),
          paymentInstruments: PaymentInstrumentsSelector(store),
          previousPageSubscription: TransactionSelectors.SubscriptionSelector(store),
          previousRoute: TransactionSelectors.PreviousRouteSelector(store),
          recordCount: TransactionSelectors.RecordCountSelector(store),
          selectedPageSizePreference: TransactionSelectors.SelectedPageSizePreference(store),
          selectedPaymentMethodId: TransactionSelectors.SelectedPaymentIdFromRouteSelector(store),
          selectedTransactionTypes: TransactionSelectors.TransactionTypesSelector(store),
          showSubscriptionBackBanner: TransactionSelectors.ShowSubscriptionBackBannerSelector(store),
          startDate: TransactionSelectors.StartDateSelector(store),
          startRecord: TransactionSelectors.StartRecordSelector(store),
          tableData: {
            columnDefs: columnDefs,
            data: transactionList
          },
          transactionResults: TransactionSelectors.TransactionResultSelector(store),
          transactionResultsFilters: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.TransactionResult, store),
          transactionResultFiltersLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TransactionResult, store),
          transactionTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.TransactionType, store),
          userPageSizePreference: SessionSelectors.PageSizePreferenceSelector(store)
        };
      };
      var controllerActions = {
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        retrieveWallet: retrieveWallet,
        searchTransactions: TransactionActions.searchTransactions,
        setBrandableCurrencyFilter: TransactionActions.setBrandableCurrencyFilter,
        setCurrencyFilter: TransactionActions.setCurrencyFilter,
        setCurrentPage: TransactionActions.setCurrentPage,
        setLockerFilter: TransactionActions.setLockerFilter,
        setPageSizePreference: TransactionActions.setPageSizePreference,
        setPaymentInstrumentFilter: TransactionActions.setPaymentInstrumentFilter,
        setTransactionResultFilter: TransactionActions.setTransactionResultFilter,
        setTransactionTypeFilter: TransactionActions.setTransactionTypeFilter,
        showSubscriptionBanner: TransactionActions.showSubscriptionBanner,
        stateGo: stateGo,
        updateDateRange: TransactionActions.updateDateRange
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.stateOrName = this.state.currentRoute;
      this.optionalParams = {
        customerId: this.state.currentCustomerId
      };
      if (!this.state.previousPageSubscription && this.state.lockerItemId) {
        this.actions.setLockerFilter(null);
      }
      if (!this.state.areBrandableCurrenciesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.BrandableCurrency);
      }
      if (!this.state.areCurrenciesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.Currency);
      }
      if (!this.state.areTransactionTypesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.TransactionType);
      }

      /** This logic is when navigated from react to set the locker filter */
      if (this.state.currentRouteParams.lockerItemId) {
        this.actions.setLockerFilter(this.state.currentRouteParams.lockerItemId);
      }

      /**This logic is added for when we redirect from react RecentPaymentFailuresTile in Account Status widget to angular transactions page
       * the filter needs to be set to filter out the successful transactions,
       * we pass a flag setPaymentFailureFilter as true from react to identify the scenario and set the Transaction Result filter.
        */
      if (this.state.currentRouteParams.setPaymentFailureFilter && !this.state.transactionResultFiltersLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.TransactionResult).then(function (transactionResults) {
          _this.setFilterFailedTransactionScenarios(transactionResults.Codes || []);
        });
      }
      if (this.state.currentRouteParams.setPaymentFailureFilter && this.state.transactionResultFiltersLoaded) {
        this.setFilterFailedTransactionScenarios(this.state.transactionResultsFilters);
      }
      this.setFilterFailedTransactionScenarios = function (transactionFilters) {
        var SUCCESSFUL_TRANSACTION = '0';
        var failedTransactionScenarios = (transactionFilters || []).filter(function (transactionResult) {
          return transactionResult.Value !== SUCCESSFUL_TRANSACTION;
        });
        _this.actions.setTransactionResultFilter(failedTransactionScenarios);
        _this.searchTransactions();
      };

      /** React logic for RecentPaymentFailuresTile ends here*/

      if (!this.state.isFetchingEwalletData) {
        this.actions.retrieveWallet({
          customerId: this.state.currentCustomerId,
          request: {
            IncludeRemoved: false
          }
        }).catch(function (payload) {
          _this.uiNotificationService.error(payload.translatedMessage, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        });
      }
      this.initDateRange(this.state.arrivedFromSearch);
    }
  }, {
    key: "hasNoData",
    get: function get() {
      return this.state.tableData.data.length === 0;
    }
  }, {
    key: "shouldShowFilterBar",
    get: function get() {
      return this.state.hasFiltersSelected || !this.hasNoData;
    }
  }, {
    key: "searchTransactions",
    value: function searchTransactions(fromSearchTransactions) {
      var _this2 = this;
      if (!this.state.selectedPageSizePreference) {
        this.actions.setPageSizePreference(this.state.userPageSizePreference);
      }
      var data = {
        BrandableCurrency: pathOr(null, ['id'], this.state.brandableCurrency),
        Currency: pathOr(null, ['id'], this.state.currency),
        End: this.state.endDate,
        LockerItemId: this.state.lockerItemId,
        PageNumber: this.state.pageNumber,
        PageSize: this.state.selectedPageSizePreference,
        PaymentInstrumentId: pathOr(null, ['id'], this.state.paymentInstrument),
        SortDirection: 2,
        Start: this.state.startDate,
        SubscriptionItemId: null,
        TransactionResults: this.state.transactionResults ? pluck('Value')(this.state.transactionResults) : null,
        TransactionTypes: this.state.selectedTransactionTypes
      };
      if (this.state.paymentInstrumentIdUrlSearchParam && !this.paymentInstrumentIdLoadedFromUrl) {
        this.actions.setPaymentInstrumentFilter({
          id: +this.state.paymentInstrumentIdUrlSearchParam,
          value: +this.state.paymentInstrumentIdUrlSearchParam
        });
        data.PaymentInstrumentId = +this.state.paymentInstrumentIdUrlSearchParam;
        this.paymentInstrumentIdLoadedFromUrl = true;
      }
      this.actions.searchTransactions(this.state.currentCustomerId, data).then(function () {
        if (_this2.state.tableData.data.length === 1 && fromSearchTransactions) {
          _this2.actions.stateGo(TRANSACTION_DETAILS_STATE, {
            transactionId: _this2.state.tableData.data[0].Id
          });
        }
      }).catch(function (payload) {
        _this2.uiNotificationService.error(payload.translatedMessage, null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "initDateRange",
    value: function initDateRange(fromSearchTransaction) {
      var entireHistoryDateShortcut = DateRangeShortcutHelper.getNullableOption(i18n.translate(LocaleKeys.ALL_TIME));
      this.shortcuts = [[entireHistoryDateShortcut].concat(DateRangeShortcutHelper.getShortListShortcuts()), DateRangeShortcutHelper.getRelativeShortListShortcuts()];
      this.selectedShortcut = entireHistoryDateShortcut;
      this.actions.updateDateRange(this.selectedShortcut.start, this.selectedShortcut.end);
      this.onPageSelected(1, fromSearchTransaction);
    }
  }, {
    key: "onDateRangeChanged",
    value: function onDateRangeChanged(startDate, endDate) {
      this.actions.updateDateRange(startDate, endDate);
      this.onPageSelected(1);
    }
  }, {
    key: "onBrandableCurrencySelected",
    value: function onBrandableCurrencySelected(selectedItem) {
      this.actions.setBrandableCurrencyFilter(selectedItem);
      this.onPageSelected(1);
    }
  }, {
    key: "onCurrencySelected",
    value: function onCurrencySelected(selectedItem) {
      this.actions.setCurrencyFilter(selectedItem);
      this.onPageSelected(1);
    }
  }, {
    key: "onPageSelected",
    value: function onPageSelected(page) {
      var fromSearchTransactions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.actions.setCurrentPage(page);
      this.searchTransactions(fromSearchTransactions);
    }
  }, {
    key: "onPageSizeOptionSelected",
    value: function onPageSizeOptionSelected(pageSize) {
      this.actions.setPageSizePreference(pageSize);
      this.onPageSelected(1);
    }
  }, {
    key: "onPaymentInstrumentSelected",
    value: function onPaymentInstrumentSelected(selectedItem) {
      this.actions.setPaymentInstrumentFilter(selectedItem);
      this.onPageSelected(1);
    }
  }, {
    key: "onTransactionTypeSelected",
    value: function onTransactionTypeSelected(selectedItems) {
      this.actions.setTransactionTypeFilter(selectedItems);
      this.onPageSelected(1);
    }
  }, {
    key: "shouldShowBackBanner",
    value: function shouldShowBackBanner() {
      return this.state && this.state.previousPageSubscription && this.state.showSubscriptionBackBanner || this.state.selectedPaymentMethodId && !this.shouldHideBackBanner;
    }
  }, {
    key: "backBannerText",
    value: function backBannerText() {
      if (pathOr(false, ['Items', 0, 'Product', 'Name'], this.state.previousPageSubscription)) {
        return this.subscriptionSecondaryNavigationLabel;
      } else if (this.state.selectedPaymentMethodId) {
        return this.walletSecondaryNavigationLabel;
      } else {
        return '';
      }
    }
  }, {
    key: "subscriptionSecondaryNavigationLabel",
    get: function get() {
      var previousName = this.state.previousPageSubscription.Items[0].Product.Name;
      return i18n.translate(LocaleKeys.TRANSACTIONS.RETURN_TO, {
        previousName: previousName
      });
    }
  }, {
    key: "walletSecondaryNavigationLabel",
    get: function get() {
      var previousName = i18n.translate(LocaleKeys.E_WALLET.TITLE);
      return i18n.translate(LocaleKeys.TRANSACTIONS.RETURN_TO, {
        previousName: previousName
      });
    }
  }, {
    key: "onBannerClose",
    value: function onBannerClose() {
      if (this.state.selectedPaymentMethodId) {
        this.shouldHideBackBanner = true;
      } else {
        this.actions.showSubscriptionBanner(false);
      }
    }
  }, {
    key: "onRemoveSubscriptionFilter",
    value: function onRemoveSubscriptionFilter() {
      this.actions.setLockerFilter(null);
      this.onPageSelected(1);
    }
  }, {
    key: "removeTransactionResultFilter",
    value: function removeTransactionResultFilter() {
      this.actions.setTransactionResultFilter([]);
      this.searchTransactions();
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.setTransactionResultFilter([]);
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {},
  controller: TransactionsListController,
  controllerAs: 'controller',
  template: require('./transactions.list.html')
};